import { createPortal } from 'react-dom';
import { useSelector } from 'react-redux';
import { makeSelectStatisticsMode } from '../../../../App/selectors';
import StatisticsPanel from './StatisticsPanel';
import useStatisticsOverlayData from './useStatisticsOverlayData';

export default function StatisticsOverlay() {
  const statisticsMode = useSelector(makeSelectStatisticsMode());

  if (!statisticsMode) return null;

  return <StatisticsOverlayPortal />;
}

function StatisticsOverlayPortal() {
  const {
    statisticsDatasets,
    statisticsSections,
    statisticsOverlayGraph,
    statisticsOverlayGraphData,
    showOverview,
    showNoFlowHighlights,
    setShowNoFlowHighlights,
    signalOverlapLast,
    showContractEfficiency,
    showExpectedContractSpeed,
    selectedDatasetKey,
    setSelectedDatasetKey,
    timeframeSelectionEndpoint,
    statisticsRangeMode,
    setStatisticsRangeMode,
    statisticsFrom,
    setStatisticsFrom,
    statisticsTo,
    setStatisticsTo,
    dataByArea,
    chartDataByArea,
    summaryByArea,
    efficiencyDataByArea,
    dailyProduction,
    gapExclusions,
    productionStops,
    averageLengths,
    loading,
    error,
    lastUpdated
  } = useStatisticsOverlayData();

  return createPortal(
    <>
      <style>{`
        @keyframes statisticsStopPulse {
          from { stroke-width: 2; stroke-opacity: 0.8; }
          to { stroke-width: 20; stroke-opacity: 0; }
        }
        @keyframes statisticsSpin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
      <StatisticsPanel
        datasets={statisticsDatasets}
        statisticsSections={statisticsSections}
        statisticsOverlayGraph={statisticsOverlayGraph}
        statisticsOverlayGraphData={statisticsOverlayGraphData}
        showOverview={showOverview}
        showNoFlowHighlights={showNoFlowHighlights}
        setShowNoFlowHighlights={setShowNoFlowHighlights}
        signalOverlapLast={signalOverlapLast}
        showContractEfficiency={showContractEfficiency}
        showExpectedContractSpeed={showExpectedContractSpeed}
        selectedDatasetKey={selectedDatasetKey}
        setSelectedDatasetKey={setSelectedDatasetKey}
        timeframeSelectionEndpoint={timeframeSelectionEndpoint}
        rangeMode={statisticsRangeMode}
        statisticsFrom={statisticsFrom}
        statisticsTo={statisticsTo}
        setStatisticsRangeMode={setStatisticsRangeMode}
        setStatisticsFrom={setStatisticsFrom}
        setStatisticsTo={setStatisticsTo}
        dataByArea={dataByArea}
        chartDataByArea={chartDataByArea}
        summaryByArea={summaryByArea}
        efficiencyDataByArea={efficiencyDataByArea}
        dailyProduction={dailyProduction}
        gapExclusions={gapExclusions}
        productionStops={productionStops}
        averageLengths={averageLengths}
        loading={loading}
        error={error}
        lastUpdated={lastUpdated}
      />
    </>,
    document.body
  );
}
